import React from 'react'
import PropTypes from 'prop-types'

const TextAreaComponent = ({
  style,
  input_style,
  label,
  rows,
  placeholder,
  name,
  value,
  onChange,
  required,
  hidden,
  disabled,
  display,
}) => {
  if (hidden) return null; // If hidden is true, skip rendering the input
  return (
    <>
      {display
        ?
        <div className={`${style}`} >
          {label !== "" &&
            <label htmlFor={name} className="form-label" >
              {label}
            </label>
          }
          <textarea
            className={`${input_style}`}
            placeholder={`Enter ${label}`}
            name={name}
            value={value}
            rows={rows}
            onChange={onChange}
            required={required}
            disabled={disabled}
          />
        </div>
        :
        <div className={`${style}`} >
          <div className="flex">
            {label !== "" &&
              <div className={`col-md-3`} >
                <label
                  className="form-label"
                  htmlFor={name}
                >
                  {label}
                </label>
              </div>
            }
            <div className={`col-md-9`} >
              <textarea
                className={`${input_style}`}
                rows={rows}
                placeholder={`Enter ${label}`}
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
      }
    </>
  )
}

TextAreaComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
}

export default TextAreaComponent
